import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { VoucherSerieResource } from "@exonn/js-sdk";

export const module: ModuleOptions<VoucherSerieResource> = {
  resource: ResourceEnum.VoucherSerie,
  smallIcon: <span className={"icon-15-vouchers"} />,
  bigIcon: <span className={"icon-20-vouchers"} />,

  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    vouchersAndGeneration: {
      title: (t) => t("formTabs.vouchers-and-generation.title"),
    },
  },
};
